import { render } from "./OfferSimulationPreview.vue?vue&type=template&id=fac22370"
import script from "./OfferSimulationPreview.vue?vue&type=script&lang=js"
export * from "./OfferSimulationPreview.vue?vue&type=script&lang=js"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__